<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <el-col :lg="8">
          {{ $t("cadastro-terceiro") }}
        </el-col>
      </div>
      <el-row type="flex" justify="end">
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button
            class="right"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
            >{{ $t("adicionar") }}</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="customer"
          :label="$t('cliente')"
          v-if="user.type === '1' || user.type === '3'"
        >
          <template slot-scope="scope">
            {{ scope.row.customer }}
          </template>
        </el-table-column>
        <el-table-column sortable prop="name" :label="$t('nome')" />
        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button v-if="(user.type !== '2' && user.type !== '5') || scope.row.customer" type="info" icon="el-icon-edit" @click="editar(scope.row.id)" circle></el-button>
            <el-button v-if="(user.type !== '2' && user.type !== '5') || scope.row.customer" type="danger" icon="el-icon-delete" @click="remove(scope.row.id, scope.row.name)" circle></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { ExternalService } from "@/services/customers/external.services";
import { UserService } from "@/services/users/user.services";

export default {
  name: "External",
  methods: {
    changeSize(size) {
      const vm = this;
      vm.fetchRecords();
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ExternalService.list()
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          vm.$notify.error({ title: i18n.tc("erro"), message: error });
        })
        .finally(() => loading.close());
    },
    add() {
      var vm = this;
      vm.$router.replace({
        name: "external.add",
      });
    },
    editar: function (id) {
      this.$router.replace({
        name: "external.edit",
        params: { id: id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-terceiro", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        ExternalService.delete(id)
          .then((response) => {
            vm.tableData.splice(
              vm.tableData.findIndex((x) => x.id === id),
              1
            );
            this.$message({
              type: "success",
              message: i18n.tc("terceiro-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.fetchRecords();
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    return {
      tableData: [],
      user: { type: "2" },
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>